export default __webpack_public_path__ + "static/media/stock.ef58b765.jpg";